
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface RegisterFieldsProps {
  firstName: string;
  lastName: string;
  company: string;
  termsAccepted: boolean;
  selectedRole: "client" | "therapist" | null;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onCompanyChange: (value: string) => void;
  onTermsAcceptedChange: (value: boolean) => void;
  onOpenTermsDialog: () => void;
}

const RegisterFields: React.FC<RegisterFieldsProps> = ({
  firstName,
  lastName,
  company,
  termsAccepted,
  selectedRole,
  onFirstNameChange,
  onLastNameChange,
  onCompanyChange,
  onTermsAcceptedChange,
  onOpenTermsDialog,
}) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName">First Name</Label>
          <Input
            id="firstName"
            type="text"
            placeholder="John"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Last Name</Label>
          <Input
            id="lastName"
            type="text"
            placeholder="Doe"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            required
          />
        </div>
      </div>

      {selectedRole === "therapist" && (
        <div className="space-y-2">
          <Label htmlFor="company">Company/Practice Name</Label>
          <Input
            id="company"
            type="text"
            placeholder="Wellness Therapy Center"
            value={company}
            onChange={(e) => onCompanyChange(e.target.value)}
          />
        </div>
      )}

      <div className="flex items-center space-x-2">
        <Checkbox
          id="terms"
          checked={termsAccepted}
          onCheckedChange={(checked) => 
            onTermsAcceptedChange(checked as boolean)
          }
          required
        />
        <Label
          htmlFor="terms"
          className="text-sm font-normal leading-none cursor-pointer"
        >
          I accept the{" "}
          <span
            className="text-[#3BAFDA] hover:text-[#1A6690] underline cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              onOpenTermsDialog();
            }}
          >
            Terms and Conditions
          </span>
        </Label>
      </div>
      {/* Add clarifying text */}
      <p className="text-xs text-[#5A636E] mt-1 ml-6">
        By checking this box, you confirm that you have read and agree to our Terms and Conditions.
      </p>
    </>
  );
};

export default RegisterFields;
